import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  Paper,
  Switch,
  Box,
  CircularProgress,
} from "@mui/material";
import Atras from "./atras";
import { auth, db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const DEFAULT_PREFS = { chat: true, newProposal: true, projectSkill: true };

const PREF_ROWS = [
  { key: "chat", label: "Mensajes de chat" },
  { key: "newProposal", label: "Nuevas propuestas en tus proyectos" },
  { key: "projectSkill", label: "Proyectos nuevos que coinciden con tus habilidades" },
];

const NotificationPreferences = () => {
  const navigate = useNavigate();
  const [prefs, setPrefs] = useState(DEFAULT_PREFS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/login");
        return;
      }
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        setPrefs({ ...DEFAULT_PREFS, ...(userDoc.data().notificationPrefs || {}) });
      }
      setLoading(false);
    };
    load();
  }, [navigate]);

  const handleToggle = async (key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    const user = auth.currentUser;
    if (user) {
      await updateDoc(doc(db, "users", user.uid), {
        [`notificationPrefs.${key}`]: next[key],
      });
    }
  };

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Atras />
          <Typography variant="h6" color="text.primary">
            Notificaciones
          </Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 15, mb: 14 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          PREF_ROWS.map((row) => (
            <Paper
              key={row.key}
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2, mb: 2 }}
            >
              <Typography>{row.label}</Typography>
              <Switch checked={!!prefs[row.key]} onChange={() => handleToggle(row.key)} />
            </Paper>
          ))
        )}
      </Container>
    </Container>
  );
};

export default NotificationPreferences;
